// pig.batches.detail - released feeder-batch record workspace
//
// PigBatchesView renders this inline record mode from the same
// pig.batches.core resource and route-local feeder writer as the hub. The
// route boundary admits only one safe id and no query/hash carrier because the
// record workspace interprets trip focus from the browser location.

import type {MigratedSurfaceDeclaration} from '../surfaceDataManifest';

const declaration: MigratedSurfaceDeclaration = Object.freeze({
  surface: 'pig.batches.detail',
  obligations: Object.freeze([Object.freeze({id: 'pig.batches.core', owner: 'permanent'})]),
  residualLegacy: Object.freeze([]),
});

export default declaration;
